module.exports = __webpack_public_path__ + "static/media/2.c8a70704.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/benefit-list/2.png
// module id = 364
// module chunks = 0